export const langCodes = {
  english: 'en-US',
  french: 'fr-CI',
};
